import { axios, saveToLocalStorage, deleteFromLocalStorage } from '@/lib/helpers';
import { createAction } from '@reduxjs/toolkit';

export const setActiveColumns = createAction('products-list-columns/active-columns/save');
export const _setActiveColumns = (activeColumns) => (dispatch) => {
  dispatch(setActiveColumns({ activeColumns }));
  saveToLocalStorage('activeProductListColumns', activeColumns);
};

export const setActiveColumnPreset = createAction('products-list-columns/active-preset/set');
export const _setActiveColumnPreset = (savedPreset) => (dispatch) => {
  if (savedPreset === null) {
    deleteFromLocalStorage('activeProductListColumnPreset');
    deleteFromLocalStorage('activeProductListColumns');
  } else {
    saveToLocalStorage('activeProductListColumnPreset', savedPreset);
    saveToLocalStorage('activeProductListColumns', savedPreset.presetColumns);
  }
  dispatch(setActiveColumnPreset({ savedPreset: savedPreset || null }));
};

export const productListColumnsRequestStarted = createAction(
  'products-list-columns/request/started'
);
export const productListColumnsRequestFailed = createAction('products-list-columns/request/failed');

export const fetchSavedProductListColumnPresetsSucceeded = createAction(
  'products-list-columns/fetch/succeeded'
);
export const fetchSavedProductListColumnPresets = (userUuid) => (dispatch, getState) => {
  const currentState = getState();
  const userState = currentState.user;
  const { chainUrls } = userState;

  if (!Object.keys(chainUrls).length) {
    return;
  }

  dispatch(productListColumnsRequestStarted());

  return axios({
    method: 'get',
    crossdomain: true,
    url: `${chainUrls.GET_SAVED_PRODUCT_LIST_COLUMN_PRESETS}userUuid=${userUuid}`,
  }).then(({ status, data }) => {
    if (status.toString().startsWith('4')) {
      dispatch(productListColumnsRequestFailed());
    } else {
      dispatch(fetchSavedProductListColumnPresetsSucceeded(data.result));
    }
  });
};

export const postSavedProductListColumnPresetSucceeded = createAction(
  'products-list-columns/post/succeeded'
);
export const postSavedProductListColumnPreset = (requestData) => (dispatch, getState) => {
  dispatch(productListColumnsRequestStarted());

  const currentState = getState();
  const userState = currentState.user;
  const { chainUrls } = userState;

  return axios({
    method: 'post',
    data: requestData,
    url: `${chainUrls.POST_SAVED_PRODUCT_LIST_COLUMN_PRESETS}`,
  }).then(
    ({ data }) => {
      if (data.result.savedPreset) {
        saveToLocalStorage('activeProductListColumnPreset', data.result.savedPreset);
        saveToLocalStorage('activeProductListColumns', data.result.savedPreset.presetColumns);
        dispatch(postSavedProductListColumnPresetSucceeded(data.result));
      } else {
        dispatch(productListColumnsRequestFailed('data.result.savedPreset missing'));
      }
    },
    ({ message }) => dispatch(productListColumnsRequestFailed(message))
  );
};

export const editSavedProductListColumnPresetSucceeded = createAction(
  'products-list-columns/edit/succeeded'
);
export const editSavedProductListColumnPreset = (preset, columns) => (dispatch, getState) => {
  dispatch(productListColumnsRequestStarted());

  const requestData = {
    ...preset,
    presetColumns: JSON.stringify(columns),
  };

  const { presetUuid, userUuid } = requestData;

  const currentState = getState();
  const userState = currentState.user;
  const { chainUrls } = userState;

  return axios({
    method: 'put',
    data: requestData,
    url: `${chainUrls.PUT_SAVED_PRODUCT_LIST_COLUMN_PRESETS}presetUuid=${presetUuid}&userUuid=${userUuid}`,
  }).then(
    ({ data }) => {
      if (data.result) {
        dispatch(editSavedProductListColumnPresetSucceeded(data.result.presets));
        dispatch(_setActiveColumnPreset(data.result.editedPreset));
      }
    },
    ({ message }) => dispatch(productListColumnsRequestFailed(message))
  );
};

export const deleteSavedProductListColumnPresetSucceeded = createAction(
  'products-list-columns/delete/succeeded'
);
export const deleteSavedProductListColumnPreset =
  (presetUuid, userUuid) => (dispatch, getState) => {
    dispatch(productListColumnsRequestStarted());

    const currentState = getState();
    const userState = currentState.user;
    const { chainUrls } = userState;

    return axios({
      method: 'delete',
      data: { presetUuid },
      url: `${chainUrls.DELETE_SAVED_PRODUCT_LIST_COLUMN_PRESETS}userUuid=${userUuid}`,
    }).then(
      ({ data }) => dispatch(deleteSavedProductListColumnPresetSucceeded(data.result)),
      ({ message }) => dispatch(productListColumnsRequestFailed(message))
    );
  };
